
import { defineComponent } from "vue";
//components
//services
import AccountService from "@/services/AccountServices";

//models
export default defineComponent({
  name: "authorization",
  props:["data" , "title"],

  data(){
    let list:any[] = []
    return{
      list,
      loading:true
    }
  },
  
  methods:{
    async init(){
      this.loading = true
      try{
        let t = JSON.stringify(this.data)
        let data:any = JSON.parse(t)
        this.list = data
      }catch(e){}
      this.loading = false
    },
    add(){
      this.list.push({actor: '' , permission:''})
    },
    remove(index:number){
      this.list.splice(index , 1)
    }
  },

  mounted(){
    this.init()
  },

  watch:{
    list:{
      handler(){
        this.$emit("setAuthorization" , this.list)
      },
      deep:true
    }
  }

});
